import { render, staticRenderFns } from "./IvBagPanel.vue?vue&type=template&id=80796a90&scoped=true&"
import script from "./IvBagPanel.vue?vue&type=script&lang=js&"
export * from "./IvBagPanel.vue?vue&type=script&lang=js&"
import style0 from "./IvBagPanel.vue?vue&type=style&index=0&id=80796a90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80796a90",
  null
  
)

export default component.exports